import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import TranslateTemplateSection from './TranslateTemplateSection';
import TranslateTemplateTextFieldGroup from './TranslateTemplateTextFieldGroup';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function TranslateTemplateNavbarSection(props) {
  const {
    languages,
    onBackClick,
    onFieldChange,
    values
  } = props;
  const names = useMemo(() => values.map(langValues => langValues.name), [values]);
  const websiteLinkTexts = useMemo(() => values.map(langValues => langValues.companyWebsiteLinkText), [values]);
  const websiteLinkUrls = useMemo(() => values.map(langValues => langValues.companyWebsiteLink), [values]);
  return /*#__PURE__*/_jsxs(TranslateTemplateSection, {
    onBackClick: onBackClick,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.templateEditor.translateModal.sections.nav.header"
    }),
    children: [/*#__PURE__*/_jsx(TranslateTemplateTextFieldGroup, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.templateEditor.translateModal.sections.nav.fieldLabels.name"
      }),
      onChange: (language, value) => onFieldChange(language, 'name', value),
      values: names,
      languages: languages
    }), /*#__PURE__*/_jsx(TranslateTemplateTextFieldGroup, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.templateEditor.translateModal.sections.nav.fieldLabels.companyWebsiteLinkText"
      }),
      onChange: (language, value) => onFieldChange(language, 'companyWebsiteLinkText', value),
      values: websiteLinkTexts,
      languages: languages
    }), /*#__PURE__*/_jsx(TranslateTemplateTextFieldGroup, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.templateEditor.translateModal.sections.nav.fieldLabels.companyWebsiteLink"
      }),
      onChange: (language, value) => onFieldChange(language, 'companyWebsiteLink', value),
      values: websiteLinkUrls,
      languages: languages
    })]
  });
}